module.exports = __webpack_public_path__ + "static/img/closeJob.26b9aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/closeJob.png
// module id = A6Cl
// module chunks = 3